// Change-feed client. Backs the SERGA OS delta poll: instead of re-pulling every
// view each minute, the frontend asks "what changed since my last poll?" and the
// server returns only the moved sources (or nothing). The `now` it returns is
// the cursor to send back next time — see SergaOS.tsx. Read-only; mirrors the
// other services' auth pattern.

import type { ProjectDetail } from "../types/dashboard";
import type { InvestmentsView, BudgetView } from "./financeService";
import type { FocusView } from "./feedService";

const API_BASE_URL = "https://api.serga.ba";

export interface ChangesResponse {
  now: string;
  changed: {
    projects?: ProjectDetail[];
    investments?: InvestmentsView;
    budget?: BudgetView;
    focus?: FocusView;
  };
}

export class ChangesService {
  private static authTokens: any = null;

  static setAuthTokens(tokens: any) {
    this.authTokens = tokens;
  }

  private static getAuthHeaders() {
    if (!this.authTokens?.idToken) {
      throw new Error("No authentication token available");
    }
    return {
      Authorization: `Bearer ${this.authTokens.idToken}`,
      "Content-Type": "application/json",
    };
  }

  /**
   * Delta since `since` (the previous response's `now`). Pass null for the
   * initial handshake — the server replies with just a cursor and an empty
   * `changed`, since full data was already loaded via the per-view endpoints.
   */
  static async getChanges(since: string | null): Promise<ChangesResponse | null> {
    const query = since ? `?since=${encodeURIComponent(since)}` : "";
    const res = await fetch(`${API_BASE_URL}/changes${query}`, {
      headers: this.getAuthHeaders(),
    });
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    return res.json();
  }
}
